module.exports = "/_next/static/images/888e5a37f2d8e37eedea92a66aba81ff-NoTransferFee.png.webp";